import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function HeroSection() {
  const [query, setQuery] = useState('');
  const navigate = useNavigate();

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (query.trim()) {
      navigate(`/category/all?search=${encodeURIComponent(query.trim())}`);
    }
  };

  return (
    <section className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20warm%20and%20elegant%20abstract%20gradient%20background%20with%20soft%20golden%20and%20cream%20tones%2C%20minimalist%20geometric%20shapes%2C%20sophisticated%20atmospheric%20lighting%2C%20cinematic%20mood%2C%20clean%20and%20modern%20aesthetic%2C%20subtle%20texture%2C%20professional%20quality%2C%20warm%20ambient%20glow&width=1800&height=900&seq=fh-hero-bg&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full max-w-3xl mx-auto px-4 md:px-6 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-background-50/15 backdrop-blur-sm rounded-full mb-6">
          <span className="w-2 h-2 bg-accent-400 rounded-full animate-pulse"></span>
          <span className="text-sm text-background-50/90">每日更新 · 海量番号库</span>
        </div>

        <h1 className="text-3xl md:text-5xl font-bold font-heading text-background-50 mb-4 leading-tight">
          专业番号查询平台
        </h1>
        <p className="text-base md:text-lg text-background-200/80 mb-8 max-w-xl mx-auto leading-relaxed">
          收录超过12万条番号信息，支持番号、演员、厂商多维度精准检索
        </p>

        <form onSubmit={handleSearch} className="flex flex-col sm:flex-row items-center gap-3 max-w-lg mx-auto">
          <div className="flex-1 w-full relative">
            <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-foreground-400 text-lg"></i>
            <input
              type="text"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="输入番号、演员名或厂商名..."
              className="w-full pl-11 pr-4 py-3.5 rounded-xl bg-background-50 border border-background-200 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-200/50 transition-all"
            />
          </div>
          <button
            type="submit"
            className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 rounded-xl text-sm font-semibold hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
          >
            <i className="ri-search-line"></i>
            搜索番号
          </button>
        </form>

        <div className="flex items-center justify-center gap-3 mt-6 flex-wrap">
          <span className="text-xs text-background-300">热门搜索：</span>
          {['SSIS-888', 'IPX-977', '桃乃木香奈', 'S1'].map((term) => (
            <button
              key={term}
              onClick={() => {
                setQuery(term);
              }}
              className="px-3 py-1 bg-background-50/10 border border-background-50/20 rounded-full text-xs text-background-200 hover:bg-background-50/20 hover:text-background-50 transition-all cursor-pointer whitespace-nowrap"
            >
              {term}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}